import { APIClient } from '@innerhive-internal/innerhive-api-client';

// The session a media token is minted by and cached under. A token carries its session's principal,
// and the download route serves only what that principal can read, so one session's token cannot
// stand in for another's: an anonymous viewer holds one session per care map they were sent.
export interface IMediaTokenSession {
    key: string;
    apiClient: Pick<APIClient, 'entry' | 'post'>;
}

export interface IMediaTokenSessions {
    getSessionServing: (href: string) => IMediaTokenSession;
}

// Registered in IoC once the app knows who is signed in: SignedInMediaTokenSessions or
// AnonymousViewerMediaTokenSessions.
export class MediaTokenSessions implements IMediaTokenSessions {
    constructor() {
        throw new Error('MediaTokenSessions should have been set in IOC');
    }

    getSessionServing = (): IMediaTokenSession => {
        throw new Error('Not Supported');
    };
}

// A signed-in user is one principal, so one token serves every href.
export class SignedInMediaTokenSessions implements IMediaTokenSessions {
    static inject = () => [APIClient];
    constructor(private apiClient: APIClient) {}

    getSessionServing = (): IMediaTokenSession => ({ key: 'user', apiClient: this.apiClient });
}
